import { Cell, Row, Spacer } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import styles from './PMSBErow.module.scss'

const DoubleCell = ({ primary, secondary, ...props }) => (
  <Cell className={styles.doubleCell} {...props}>
    <div className={styles.doubleCellPrimary}>{primary}</div>
    <div className={styles.doubleCellSecondary}>avr. {secondary}</div>
  </Cell>
)

const TotalRow = ({ balanceLate, balanceCurrent, paymentAmount, count }) => (
  <Row className={styles.totalRow}>
    <Spacer />
    <DoubleCell primary="TOTAL" secondary={`For ${count} hotels`} />
    <Spacer />
    <DoubleCell
      primary={formatPrice(balanceCurrent)}
      secondary={formatPrice(balanceCurrent / count)}
    />
    <DoubleCell
      primary={formatPrice(balanceLate)}
      secondary={formatPrice(balanceLate / count)}
    />
    <DoubleCell
      primary={formatPrice(paymentAmount)}
      secondary={formatPrice(paymentAmount / count)}
    />
    <Spacer />
    <Spacer />
  </Row>
)

export default TotalRow
